<script>
  import { digitalLoadMethods, digitalLoadComputed, layoutMethods, erpUserRolesMethods } from '@/state/helpers';
  import Swal from 'sweetalert2';
  import { getModuleAccess } from '@/router/helper.js'

  // import { required } from "vuelidate/lib/validators";
  /**
   * E-Load Banner component
   */
  export default {
    page: {
      title: "E-Load Banner",
    },
    data() {
      return {
        title: "E-Load Banner",
        fieldsBanner: [
          {
            key: 'action',
            sortable: false,
          },
          {
            key: 'banner_name',
            sortable: true
          },
          {
            key: 'image',
            sortable: false
          },
          {
            key: 'sequence',
            sortable: true,
          },
          {
            key: 'status',
            sortable: true,
          },
        ],
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        pagination: {
          rows: 10,
          page: 1,
          search: null,
          searchField: null,
          status:null,
          bannerId: 0,
          sortBy: "id",
          sortDesc: false,
        },
        searchOptions: [
          {text: 'Search All', value:null},
          {text: 'Name', value:'name'}
        ],
        statusList: [
          { text: "All", value: null },
          { text: "Active", value: 1 },
          { text: "Inactive", value: 0 }
        ],
        prev_sort: '',
        eloadBannerModule: {
          access: {
            create: true,
            update: true,
            delete: true
          }
        }
      };
    },
    async mounted() {
      this.changeTitle({title: 'E-Load Banner'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'}},
          { text: 'Digital Load', to: { name: 'Digital Load'} },
          { text: 'E-Load Banner', to: { name: 'E-Load Banner'} }
        ]
      });
      this.getBannerList();

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Products', 'eLoad', 'eLoad Banner')
      .then((access) => this.eloadBannerModule.access = access);
      console.log(":: eloadBannerModule ::",JSON.stringify(this.eloadBannerModule))

    },
    computed: {
      ...digitalLoadComputed
    },
    methods: {
      ...layoutMethods,
      ...digitalLoadMethods,
      ...erpUserRolesMethods,
      getBannerList(state ='') {
        if(state == 'reset'){
          this.pagination.page = 1;
        }
        this.getEloadBannerList(this.pagination)
        .then(function(res){
          console.log("check:",res);
        })
        .catch(function(e){
            Swal.fire("Loading Failed!", `${e}`, "error");
        });
      },
      deleteEloadBannerItem(data){
        if (!this.eloadBannerModule.access.delete) {
          Swal.fire(
            "Access Restricted",
            "You are not allowed to delete a Banner.",
            "warning"
          );
        } else {
          Swal.fire({
              title: 'Are you sure?',
              text: `Do you really want to delete ${data.name}? This process cannot be undone.`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                this.deleteEloadBanner(data.id)
                .then(() => {
                  Swal.fire("Delete Successful!", `${data.name} has been deleted.`, "success");
                  this.getBannerList();
                })
                .catch((error) => {
                  Swal.fire("Delete Failed!", `An Error Occured: ${error}`, "danger");
                });
              }else{
                  return;
              }
          })
          console.log(">> DELETE:", event);
        }
      },
      editEloadBanner(data){
        console.log(">> EDIT:", data);
        this.$router.push(
          this.$route.query.redirectFrom || {
            name: "E-Load Banner Form", params: { id: data.id }
          }
        );
      },
      onDisplayChange(){
        console.log(this.loadBannerTotalRows,this.pagination.rows,this.loadBannerList.length,(this.loadBannerList.length < this.loadBannerTotalRows && this.loadBannerList.length != this.pagination.rows));
        if(
          (this.loadBannerList.length < this.loadBannerTotalRows && this.loadBannerList.length != this.pagination.rows) || // condition for incrementing display per page
          (this.loadBannerList.length == this.loadBannerTotalRows && this.pagination.rows < this.loadBannerList.length) // condition for decreasing display per page
          ){
          this.pagination.page=1;
          this.getBannerList('reset')
        }
      },
      refresh(){
        this.getBannerList();
      },
      bannerSort(ctx){
        this.pagination.sort = ctx.sortBy;
        this.pagination.orderDesc = ctx.sortDesc;
        console.log(">> sorting",this.pagination);
        if(this.prev_sort != ctx.sortBy){
          this.prev_sort = ctx.sortBy
          this.pagination.page = 1
        }
        this.getBannerList();
      },
    }
  }
    
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-4">
                <div class="mt-2">
                  <h5 class="card-title">
                    <span class="fw-normal ms-2">{{loadBannerTotalRows}}</span> Record(s)
                  </h5>
                </div>
              </div>
              <!-- end col -->

              <!-- Search and button -->
              <div class="col-md-8 col-sm-8"> 

                 <div class="d-flex justify-content-end">
                    <div>
                    <router-link v-if="eloadBannerModule.access.create" :to="{ name: 'E-Load Banner Form', params: { id: 0 }}" class="tc-white">
                      <b-button variant="primary" class="me-2"><i class="uil uil-plus me-1"></i> Add Banner</b-button>
                    </router-link>
                      <a class="btn btn-secondary"
                        ><feather
                          type="refresh-ccw"
                          size="16"
                          class="icon nav-icon"
                        ></feather
                        >&nbsp;&nbsp; Refresh</a
                      >
                        <!-- @click="refresh()" -->
                    </div>
                </div>
                
              </div>
              <!-- end col -->

              <div class="col-sm-4 ta-right mt-3">
                  <b-form-group description="Search Keyword">
                    <form class="d-flex"  @submit.prevent="getBannerList('reset')"  >
                      <b-form-group id="input-group-3" label-for="input-3">
                        <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                          id="input-3"
                          v-model="pagination.searchField"
                          :options="searchOptions"
                        ></b-form-select>
                      </b-form-group>

                      <b-input-group>
                        <b-form-input v-model="pagination.search" class="rounded-0"></b-form-input>
                        <b-input-group-append>
                        </b-input-group-append>
                      </b-input-group>
                    </form>
                  </b-form-group>
              </div>
                <div class="col-md-8 mt-3">
                  <div
                    class="
                      d-flex
                      flex-wrap
                      align-items-start
                      mt-2 mt-md-0
                      gap-2
                      mb-3 ta-right
                    "
                  >
                    <b-form-group label-for="status" description="Filter by status">
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:fit-content"
                        v-model="pagination.status"
                        :options="statusList"
                      ></b-form-select>
                    </b-form-group>
                    <a class="btn btn-primary h-fit" @click="getBannerList('reset')">
                      <i class='bx bx-search bx-fw'></i>Search
                    </a>
                  </div>
                </div>
            </div>
            <!-- end row -->

            <!-- table responsive -->
            <div class="table-responsive">
              <div class="table align-middle table-nowrap text-center">
                <b-table
                  :items="loadBannerList"
                  :fields="fieldsBanner"
                  responsive="sm"
                  @sort-changed="bannerSort"
                  :sort-by.sync="pagination.sortBy"
                  :sort-desc.sync="pagination.sortDesc"
                >

                  <template #cell(action)="data">
                    <div class="d-flex">
                      <b-button id="show-btn" class="btn btn-sm btn-danger" @click="deleteEloadBannerItem(data.item)"><i class="bx bx-trash bx-xs bx-fw"></i></b-button>
                    </div>
                  </template>
                  <template #cell(banner_name)="data">
                    <span class="text-body m-0 text-capitalize">
                      <b-link @click="editEloadBanner(data.item)">
                        {{data.item.name}}
                      </b-link>
                    </span>
                  </template>
                  <template #cell(image)="data">
                    <img
                    :src="data.item.bannerImageSrc"
                    alt="Banner Image"
                    @error="(e) => e.target.src = require('@/assets/images/img-placeholder.png')"
                    class="border-end img-fluid border-0 rounded-start img-cover"
                    style="width: 60px;"
                    />
                  </template>
                  <template #cell(sequence)="data">
                    <span>{{data.item.sequence}} </span>
                  </template>
                  <template #cell(status)="data">
                    <div class="btn not-allowed">
                        <div class="form-check form-switch not-allowed">
                            <input :disabled="true || !eloadBannerModule.access.update"
                                class="form-check-input"
                                v-model="data.item.status"
                                type="checkbox"
                                id="flexSwitchCheckDefault"
                            />
                        </div>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
            <!-- end table responsive -->
            <div class="row g-0 text-center" v-if="loadBannerTotalRows == 0">
              <span>No data to display.</span>
            </div>
            <div class="row g-0 text-center text-sm-start" v-if="loadBannerTotalRows != 0  && loadBannerTotalRows > 10">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="pagination.rows"
                            :options="pageOptions"
                            @change="onDisplayChange()"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      "
                    >
                      <b-pagination  v-if="loadBannerTotalRows != 0 && loadBannerTotalRows > 10 && loadBannerTotalRows > pagination.rows"
                        class="pagination-rounded"
                        v-model="pagination.page"
                        @input="getBannerList"
                        :total-rows="loadBannerTotalRows"
                        :per-page="pagination.rows"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>

          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

  </div>
</template>
<style>
 .not-allowed{cursor:not-allowed;}
</style>